import React from 'react';
import type { EvaluationPlanAttachment, EvaluationPlanAttachmentSlot } from '../../types/evaluationPlan';
import { EVALUATION_PLAN_ATTACHMENT_SLOT_LABELS } from '../../types/evaluationPlan';

const EvaluationPlanAttachmentPreviewModal: React.FC<{
  open: boolean;
  slot: EvaluationPlanAttachmentSlot | null;
  attachment: EvaluationPlanAttachment | null;
  onClose: () => void;
  stackAboveDocumentList?: boolean;
}> = ({ open, slot, attachment, onClose, stackAboveDocumentList = false }) => {
  if (!open || !slot || !attachment) return null;

  const title = EVALUATION_PLAN_ATTACHMENT_SLOT_LABELS[slot];
  const registeredAt = new Date(attachment.registered_at);
  const registeredLabel = Number.isNaN(registeredAt.getTime())
    ? attachment.registered_at
    : registeredAt.toLocaleString('ko-KR');

  return (
    <div
      className={
        'cp-modal-backdrop cp-evaluation-plan-attachment-preview-backdrop' +
        (stackAboveDocumentList ? ' cp-evaluation-plan-viewer-backdrop--above-doc-list' : '')
      }
      role="presentation"
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onClose();
      }}
    >
      <div
        className="cp-modal cp-evaluation-plan-attachment-preview-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-evaluation-plan-attachment-preview-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="cp-evaluation-plan-attachment-preview-title">{title}</h3>
        <div className="cp-modal-body cp-evaluation-plan-attachment-preview-body">
          {attachment.kind === 'share_link' && attachment.share_url ? (
            <p className="cp-evaluation-plan-attachment-preview-lead">
              등록된 공유링크: <strong>{attachment.share_url}</strong>
            </p>
          ) : attachment.kind === 'file' && attachment.file_name ? (
            <p className="cp-evaluation-plan-attachment-preview-lead">
              등록된 파일: <strong>{attachment.file_name}</strong>
            </p>
          ) : attachment.kind === 'form' ? (
            <p className="cp-evaluation-plan-attachment-preview-lead">등록된 양식 데이터가 있습니다.</p>
          ) : (
            <p className="cp-evaluation-plan-attachment-preview-lead">
              {attachment.preview_label ?? title}이(가) 등록되어 있습니다.
            </p>
          )}
          <p className="cp-evaluation-plan-attachment-preview-meta">등록 시각: {registeredLabel}</p>
          <p className="cp-evaluation-plan-attachment-preview-hint" role="status">
            파일 미리보기·양식 편집 기능은 준비 중입니다.
          </p>
        </div>
        <div className="cp-modal-footer">
          <button type="button" className="cp-btn-primary" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default EvaluationPlanAttachmentPreviewModal;
